export default __webpack_public_path__ + "add-app-button-background.png";